import Enuns from "@/plugins/Enums"

export default {
	methods:{
		enableAction(file, field){
			if (this.dc4 && this.dc4.lstDc5){
				let dc5 = this.dc4.lstDc5.filter(dc5 => dc5.dc5arquivo.toLowerCase() == file.toLowerCase())[0]
				if (!dc5)
					return false

				return dc5[field]
			}
			return false
		},
		getLabel(field){
			if (this.lstDc1 == null)
				return ""
			return  this.lstDc1.filter(dc1 => dc1.dc1campo.toLowerCase() == field)[0]?.dc1nome
		},
		getType(field){
			if (this.lstDc1 == null)
				return "text"
			return  this.getDc1Type(this.lstDc1.filter(dc1 => dc1.dc1campo.toLowerCase() == field)[0]?.dc1tipo)
		},
		getHelp(field){
			if (this.lstDc1 == null)
				return "text"
			return  `${field.toUpperCase()} - ${this.lstDc1.filter(dc1 => dc1.dc1campo.toLowerCase() == field)[0]?.dc1ajuda}`
		},
		getDc1Decimal(field) {
			if (!this.lstDc1 || !Array.isArray(this.lstDc1)) return 2; 
			const dc1 = this.lstDc1.find(dc1 => dc1.dc1campo.toLowerCase() === field.toLowerCase());
			return dc1 ? dc1.dc1decimal : 2; 
		},
		getDc1edicao(field){
			if (this.lstDc1 == null)
				return Enuns.Dc1EdicaoType.Normal
			return this.lstDc1.filter(dc1 => dc1.dc1campo.toLowerCase() == field)[0]?.dc1edicao
		},
		enableEdit(field){
			switch (this.getDc1edicao(field)) {
				case Enuns.Dc1EdicaoType.Normal:
					return true
				case Enuns.Dc1EdicaoType.Insert:
					return this.insert
				case Enuns.Dc1EdicaoType.NotEditable:
					return false
				default:
					return false;
			}        
		},
		invisible(field){
			return Enuns.Dc1EdicaoType.Invisible == this.getDc1edicao(field)
		},
		getRules(field, formattersRules = [], disabled = false) {
			if (this.enableEdit(field) == false)
				return []
			
			if (this.lstDc1 == null)
				return formattersRules

			let dc1nulo = this.lstDc1.filter(dc1 => dc1.dc1campo.toLowerCase() == field)[0]?.dc1nulo
			let dc1espaco = this.lstDc1.filter(dc1 => dc1.dc1campo.toLowerCase() == field)[0]?.dc1espaco

			let value

			let rules = [ val => {
				if (disabled) {
					return true
				}
				switch (typeof(val)) {
					case "boolean":
						return true
					case "number":
						if ((!val && dc1nulo) || !!val) {
							return true
						}
						break
					default:
						if (dc1nulo && (val == "" || val == null || val == undefined)){
							return true
						}

						value = (val == null || val == undefined) ? "" : val

						if (typeof(value) == "object") {
							value = value.toString()
						}

						if(value && value.trim().length > 0)
							return true
						if (dc1espaco && value.length > 0 && value.trim()  == "")
							return true
							
						break;
				}
			
				return "Campo obrigatório"
			}]

			rules = rules.concat(formattersRules)
			return rules
		},
		getFormName(form) {
			if (this.lstDc0 == null)
				return ""
			return this.lstDc0.filter(dc0 => dc0.dc0arquivo.toUpperCase() == form)[0]?.dc0nome
		},
		getMask(field) {
			let mask = undefined

			if (this.lstDc1 == null)
				return mask
			let dc1 = this.lstDc1.filter(dc1 => dc1.dc1campo.toLowerCase() == field)[0]
			if (!dc1 || dc1.dc1tipo != "C"){
				return mask
			}

			let isKey = dc1.dc1chave
			if (dc1.dc1campai && dc1.dc1campai.trim().length > 0 && dc1.dc1arqpai && dc1.dc1arqpai.trim().length > 0) {
				let dc1pai = this.lstDc1.filter(dc1 => dc1.dc1campo.toLowerCase() == dc1.dc1campai)[0]
				if (dc1pai) {
					isKey = dc1pai.dc1chave
				}
			}

			switch (dc1.dc1formato) {
				case 0: mask = "X".repeat(dc1.dc1tamanho); break;
				case 1: mask = "#".repeat(dc1.dc1tamanho); break;
				case 6: mask = "U".repeat(dc1.dc1tamanho); break;
			}

			return mask
		},
		padLeftZero(field, value) {
			if (!this.lstDc1 || value === "" || value === null || value === undefined) {
				return value; 
			}

			const dc1 = this.lstDc1.find(dc1 => dc1.dc1campo.toLowerCase() === field);
			if (!dc1 || dc1.dc1formato !== 1) return value;

			return String(value).padStart(dc1.dc1tamanho, "0");
		},
		limitDecimalByDict(field, value) {
			if (this.lstDc1 == null || !value) return value;
			let dc1 = this.lstDc1.filter(dc1 => dc1.dc1campo.toLowerCase() === field)[0];
			if (!dc1) return value;

			let controllLimit = dc1.dc1tamanho;

			let [inteiro, decimal] = value.toString().split('.');
			if (!inteiro) inteiro = '0';

			if (inteiro.length > controllLimit) {
				inteiro = inteiro.slice(0, controllLimit);
				return inteiro;
			}

			return value
		},
		formatMask(value, field, prefix = "0"){
			let dc1 = this.lstDc1.filter(dc1 => dc1.dc1campo.toLowerCase() == field)[0]
			return value.padStart(dc1.dc1tamanho, prefix)
		},
		getMaxLength(field) {
			if (this.lstDc1 == null)
				return 0
			return this.lstDc1.find(dc1 => dc1.dc1campo.toLowerCase() == field).dc1tamanho ?? 0
		},
		getMaxLengthsForCurrencyField(field){
			let mask = undefined

			if (this.lstDc1 == null)
				return mask
			let dc1 = this.lstDc1.filter(dc1 => dc1.dc1campo.toLowerCase() == field)[0]
			if (!dc1){
				return mask
			}

			return {
				decimalLength: dc1.dc1decimal,
				max: Number("9".repeat(dc1.dc1tamanho) + "." + "9".repeat(dc1.dc1decimal))
            }
		}
	}
}